import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UninterruptedOperationHero from "./sections/UninterruptedOperationHero";
import DsServicesInNumbers from "./sections/DsServicesInNumbers";
import IntegratedTechnologySolutions from "./sections/IntegratedTechnologySolutions";
import AbsoluteSecurityControl from "./sections/AbsoluteSecurityControl";
import CertifiedReliability from "./sections/CertifiedReliability";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <UninterruptedOperationHero />
      <DsServicesInNumbers />
      <IntegratedTechnologySolutions />
      <AbsoluteSecurityControl />
      <CertifiedReliability />
      <Testimonials />
      <Footer />
    </div>;
}